import { type FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Typography,
  View,
  XStack,
  YStack,
} from '@shinetools/sunshine-universal';

import SunshineCard from 'components/_core/SunshineCard';

import ChallengeRequestOriginDetails from './ChallengeRequestOriginDetails';
import { getOperationDetails } from './getOperation';

export interface ChallengeRequestOperationDetailsProps {
  challengeId: string;
  operation: string;
  originDeviceId: string;
  payload: Record<string, unknown>;
}

const ChallengeRequestOperationDetails: FC<
  ChallengeRequestOperationDetailsProps
> = ({ challengeId, operation, originDeviceId }) => {
  const { icon, title } = getOperationDetails(operation);

  return (
    <>
      <View paddingVertical="$space.16">
        <Typography.Text size="small" textAlign="justify" variant="secondary">
          <FormattedMessage id="authentication.challenge.operation_details_title" />
        </Typography.Text>
      </View>
      <SunshineCard.Group>
        <YStack borderColor="$grey.200" borderRadius={8}>
          <SunshineCard alignItems="center">
            <SunshineCard.Slot name="aside">{icon}</SunshineCard.Slot>

            <XStack>
              <SunshineCard.Content alignContent="center" width="100%">
                <SunshineCard.Title>{title}</SunshineCard.Title>
              </SunshineCard.Content>
            </XStack>
          </SunshineCard>

          <ChallengeRequestOriginDetails
            challengeId={challengeId}
            originDeviceId={originDeviceId}
          />
        </YStack>
      </SunshineCard.Group>
    </>
  );
};

export default ChallengeRequestOperationDetails;
